import React, { FC, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import cls from 'classnames';

import CrossSellingBanner from '@ott/cross-selling-banner';
import CoinsIcon from '@ott/icon-coins';
import { l10n, l10nhtml, lang } from '@ott/l10n';
import {
  helpers as virtualCardHelpers,
  selectors as virtualCardSelectors,
  hooks as virtualCardHooks,
} from '@ott/shared-virtual-card-logic';
import KM from '@ott/utility-km';

import styles from './ReleaseBanner.scss';

const {
  virtualCardFlow: { useVirtualCardFlow },
} = virtualCardHooks;

type Props = {
  /**
   * Класс для стилизации
   * */
  className?: string;
  /**
   * Поля для метрики
   * */
  kmParams?: Record<string, any>;
  /**
   * Автоматический выпуск карты после авторизации/регистрации по телефону
   */
  withQuickAuthorization?: boolean;
};

const ReleaseBanner: FC<Props> = (props) => {
  const { className = '', kmParams = {}, withQuickAuthorization = false } = props;

  const {
    openReleaseModal,
    auth: { isAuthorized },
  } = useVirtualCardFlow();

  const { data: virtualCardData, loading: isVirtualCardLoading } = useSelector(
    virtualCardSelectors.getCardInfo
  );
  const { data: paymentCheckData } = useSelector(virtualCardSelectors.getPaymentCheck);
  const isVirtualCardDisabled = useSelector(virtualCardHelpers.isVirtualCardDisabled);

  const [bonusesAmount, setBonusesAmount] = useState(0);

  useEffect(() => {
    if (paymentCheckData) {
      setBonusesAmount(Math.floor(paymentCheckData?.bonuses?.amount || 0));
    }
  }, [paymentCheckData]);

  const handleBannerClick = useCallback(() => {
    KM('Virtual_Card_Payment_Issue_Press', { obj: kmParams });
    openReleaseModal({ withQuickAuthorization }, { common: { kmParams } });
  }, [isAuthorized, kmParams]);

  const isVirtualCardIssued =
    !isVirtualCardLoading && isAuthorized && Boolean(virtualCardData?.phone);
  const isVirtualCardLimit = isVirtualCardDisabled && paymentCheckData;
  const isRULocale = lang === 'ru';

  if (isVirtualCardIssued || isVirtualCardLimit || !isRULocale || !bonusesAmount) {
    return null;
  }

  return (
    <CrossSellingBanner
      title={l10n('virtualCard.releasePromo.title')}
      description={l10nhtml('virtualCard.tripcoinsForOrder', {
        tripcoins: Math.floor(bonusesAmount),
      })}
      icon={<CoinsIcon />}
      onClick={handleBannerClick}
      className={cls(styles.releaseBanner, className)}
      childrenClassNames={{
        action: styles.action,
        arrow: styles.arrow,
        description: styles.description,
      }}
    />
  );
};

export default ReleaseBanner;
